import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
	EmptyStateComponent,
	IconComponent,
	InfoGroupComponent,
	ModalComponent,
	TagComponent,
} from '@tecalisdev/infinity';
import { IProcessDetailResponse } from '../../models/processes.models';
import { MasterService } from '../../../shared/services/master.service';
import { CommonModule } from '@angular/common';
import { ExpirationDatePipe } from '../../../core/pipes/expiration-date.pipe';
import { SafeDatePipe } from '../../../core/pipes/safe-date.pipe';
import { NOT_AVAILABLE_DISPLAY } from '../../../core/utils/utils';

@Component({
	selector: 'app-modal-identity-process-detail',
	standalone: true,
	imports: [
		CommonModule,
		TranslatePipe,
		SafeDatePipe,
		ExpirationDatePipe,
		ModalComponent,
		InfoGroupComponent,
		IconComponent,
		TagComponent,
		EmptyStateComponent,
	],
	templateUrl: './modal-identity-process-detail.component.html',
	styleUrl: './modal-identity-process-detail.component.scss',
})
export class ModalIdentityProcessDetailComponent {
	@Input() identity?: IProcessDetailResponse['identity'] | null;
	@Input() fullName: string = NOT_AVAILABLE_DISPLAY;
	@Input() yearsOld: number | null = null;
	@Input() nationalityFallback?: string | null;
	@Output() closeEvent = new EventEmitter<void>();

	public masterService = inject(MasterService);

	public closeModal(): void {
		this.closeEvent.emit();
	}
}
